import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from '../../../services/general.service';
import { GroupService } from '../../../services/group.service';

@Component({
  selector: 'app-office',
  templateUrl: './office.component.html',
  styleUrls: ['./office.component.scss']
})
export class OfficeComponent implements OnInit {
  userId: any;
  userToken: any;
  textButton: any;
  loadBtn = false;
  type: any;
  office: any = {};
  listCompanies: any;
  editId: any;

  constructor(private toastr: ToastrService, public dialogRef: MatDialogRef<OfficeComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private gralService: GeneralService, private groupService: GroupService) {
    this.type = this.data.type;
    this.userId = this.data.userId;
    this.userToken = this.data.userToken;
    this.listCompanies = this.data.companies;

    if(this.type === 'add'){
      this.textButton = 'ADDOFFICE';
    }else{
      this.office = this.data.info;
      this.office.company = this.data.info.company.id;
      this.editId = this.data.id;
      this.textButton = 'EDITOFFICE';
    }
  }

  ngOnInit() {
  }

  onCloseConfirm() {
    if(!this.office.company || !this.office.name || !this.office.country){
      this.toastr.error('Favor de llenar los campos obligatorios', 'Error al agregar sucursal');
      return false;
    }

    this.loadBtn = true;
    if(this.type == 'add'){
      this.groupService.newOffice(this.office, this.userId, this.userToken).then((data) => {
        this.loadBtn = false;
        this.dialogRef.close({ data: data['msg'] });
      }, (err) => {
        this.loadBtn = false;
        console.log(err);
        this.toastr.error(err['error'].msg, 'Error al generar contraseña');
      });
    }

    if(this.type == 'edit'){
      this.groupService.updateOffice(this.editId, this.office, this.userId, this.userToken).then((data) => {
        this.loadBtn = false;
        this.dialogRef.close({ data: data['msg'] });
      }, (err) => {
        this.loadBtn = false;
        console.log(err);
        this.toastr.error(err['error'].msg, 'Error al generar contraseña');
      });
    }
  }

  onCloseCancel() {
    this.dialogRef.close();
  }

  getcp(ev){
    if(ev.target.value.length == 5){
      this.gralService.getPostalCode(ev.target.value).then((data) => {
        this.office.state = data['estado'];
        this.office.city = data['municipio'];
      }, (err) => {
        console.warn(err);
      });
    }
  }
}
